module.exports = __webpack_public_path__ + "img/6.807db283.png";